// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"828":"461cd438","3440":"da1cfe11","5424":"a248cef0"}[chunkId] + ".chunk.css");